// extracted by mini-css-extract-plugin
export default {"root":"button__root","fullWidth":"button__fullWidth"};